import { PartialDeep } from './partial-deep';

// deep merge two objects and its sub-objects
export function deepMerge<T extends object>(target: T = {} as any, source: PartialDeep<T> = {} as any): T {
  const result: any = { ...target };
  for (const key in source) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      result[key] = deepMerge(result[key], source[key]);
    } else {
      result[key] = source[key];
    }
  }
  return result;
}

// deep merge multiple objects and its sub-objects
export function deepMergeMultiple<T extends object>(...sources: PartialDeep<T>[]): T {
  return sources.reduce((acc, source) => deepMerge(acc, source), {} as T);
}
